import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label, Wrapper } from './ResultsViewToggle.styles';
import Toggler from '../../../../Toggler/Toggler';

export type ResultsViewMode = 'all' | 'categorized';

interface ResultsViewToggleProps {
  viewMode: ResultsViewMode;
  onChange: (viewMode: ResultsViewMode) => void;
}

const ResultsViewToggle: React.FC<ResultsViewToggleProps> = ({ viewMode, onChange }) => {
  const { t } = useTranslation();
  const isCategorized = viewMode === 'categorized';

  const handleToggleState = () => {
    onChange(isCategorized ? 'all' : 'categorized');
  };

  return (
    <Wrapper>
      <Toggler name="viewMode" active={isCategorized} handleToggleState={handleToggleState} />
      <Label active={isCategorized} onClick={handleToggleState}>
        {t('report.effect.viewToggle.categorized')}
      </Label>
    </Wrapper>
  );
};

export default ResultsViewToggle;
